import Swiper from 'swiper';
import { Navigation, Controller } from 'swiper/modules';

class TvsGallery extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const sliderImage = new Swiper(".section-product-image", {
            modules: [Navigation, Controller],
            navigation: {
                nextEl: ".button-next",
                prevEl: ".button-prev",
            },
            loop: false,
            breakpoints: {
                640: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1110: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
            },
        });

        const sliderDescription = new Swiper(".section-product-description", {
            autoHeight: true,
            breakpoints: {
                640: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1110: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
            },
        });
        sliderImage.controller.control = sliderDescription;

        try {
            const myInterval = setInterval(divHeight, 300);

            function divHeight() {
                function divHeight(elements) {
                    let maxHeight = 0;
                    elements.forEach(element => {
                        maxHeight = Math.max(maxHeight, element.offsetHeight);
                    });
                    elements.forEach(element => {
                        element.style.height = `${maxHeight}px`;
                    });
                }

                const elements = document.querySelectorAll('.description');
                divHeight(Array.from(elements));
            }

            function stop() {
                clearInterval(myInterval);
            }
        } catch (error) {
            console.log('error');
        }

    }
}

customElements.define('tvs-gallery', TvsGallery);